export const RAMBO_LIST_REQUEST     = 'RAMBO_LIST_REQUEST';
export const RAMBO_LIST_SUCCESS     = 'RAMBO_LIST_SUCCESS';
export const RAMBO_LIST_FAIL        = 'RAMBO_LIST_FAIL';
export const RAMBO_LIST_UPDATE      = 'RAMBO_LIST_UPDATE';